import { useState } from 'react';

import { ActionItemStatus } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';

import { AddMatchingAvailability } from './todo-items/AddMatchingAvailability';
import { Credentialing } from './todo-items/Credentialing';
import { SelectStates } from './todo-items/SelectStates';
import { SetupMatchingProfile } from './todo-items/SetupMatchingProfile';
import { AddMfa } from './todo-items/AddMfa';
import { ConfigurePayoutAccount } from './todo-items/ConfigurePayoutAccount';

export type OnboardingTaskProps = {
  task: string;
  status: ActionItemStatus;
};

export const OnboardingTask: React.VFC<OnboardingTaskProps> = ({ task, status }): JSX.Element | null => {
  const [ isSelectStatesModalOpen, setIsSelectStatesModalOpen ] = useState(false);
  const [ isMfaModalOpen, setIsMfaModalOpen ] = useState(false);
  const me = useCurrentuser();
  const isProviderMSOPartner = me?.rules?.msoPartner;

  const handleCloseModal = () => setIsSelectStatesModalOpen(false);
  const handleCloseMfaModal = () => setIsMfaModalOpen(false);

  switch (task) {
    case 'credentialing':
      return (
        <Credentialing
          key={task}
          status={status}
          isSelectStatesModalOpen={isSelectStatesModalOpen}
          setIsSelectStatesModalOpen={setIsSelectStatesModalOpen}
          handleCloseModal={handleCloseModal}
        />
      );
    case 'stateSelection':
      return (
        <SelectStates
          key={task}
          status={status}
          isSelectStatesModalOpen={isSelectStatesModalOpen}
          setIsSelectStatesModalOpen={setIsSelectStatesModalOpen}
          handleCloseModal={handleCloseModal}
        />
      );
    case 'matchingProfile':
      return <SetupMatchingProfile key={task} status={status}/>;
    case 'matchingAvailability':
      return isProviderMSOPartner ? null : <AddMatchingAvailability key={task} status={status}/>;
    case 'payoutAccountConfigured':
      return <ConfigurePayoutAccount key={task} status={status} />;
    case 'mfaAdded':
      return (
        <AddMfa
          key={task}
          status={status}
          isModalOpen={isMfaModalOpen}
          setIsModalOpen={setIsMfaModalOpen}
          handleCloseModal={handleCloseMfaModal}
        />
      );
    default:
      return null;
  }
};
